<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'
      :count= 'count'
      :current="page"
      :showEmptyLine="true"
    >
      <div slot="table">
        <div class="btns">
          <lk-button  @click="handleUpload" type='primary'>进销存上传</lk-button>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
  </template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import healthInsManage from '../../services/healthInsManage';

export default {
  name: 'drugDull',
  mixins: [mapState, queryMixins],
  data() {
    return {
      disablePage: false,
      haveUpload: false,
      page: 1,
      size: 20,
      count: 0,
      columns: [
        { title: '序号', type: 'index', width: 60 },
        { title: '门店名称', key: 'storeName', minWidth: 90 },
        { title: '操作类型', key: 'codeDesc', minWidth: 60 },
        {
          title: '时间范围',
          key: 'approvedName',
          minWidth: 186,
          render: (h, { row }) => h('span', `${utils.formatDateToSecond(row.beginTime)}~${utils.formatDateToSecond(row.endTime)}`),
        },
        {
          title: '上传状态',
          key: 'status',
          width: 90,
          render: (h, { row }) => h('span', row.status == 1 ? '成功' : '失败'),
        },
        { title: '上传结果', key: 'remark', minWidth: 150 },
        { title: '操作人', key: 'createUserName', minWidth: 90 },
        {
          title: '操作时间',
          key: 'modifiedTime',
          width: 150,
          render: (h, { row }) => h('span', utils.formatDateToSecond(row.createTime)),
        },
        {
          title: '操作',
          key: 'addBtn',
          render: (h, params) => {
            return h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.handleReupload(params.row);
                },
              },
            }, params.row.status == 1 ? '' : '重新上传');
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handleUpload() {
      if (this.haveUpload) {
        this.$Message.success('进销存上传中，请一分钟后刷新页面查看');
        return;
      }
      healthInsManage.importUpload().then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        } else {
          this.$Message.success('进销存上传中，请稍后查看上传结果');
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      healthInsManage.importList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.count = res.data.data.count;
          this.tableData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleReupload(value) {
      if (value.haveUpload) {
        this.$Message.success('进销存上传中，请一分钟后刷新页面查看');
        return;
      }
      const tempP = {
        medJobRecordId: value.id,
        storeId: value.storeId,
        storeName: value.storeName,
        code: value.code,
      };
      value.haveUpload = true;
      healthInsManage.importUpload(tempP).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        } else {
          this.$Message.success('进销存上传中，请稍后查看上传结果');
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getData();
  },
  components: {
    QueryFrame,
  },
};
</script>
<style>
  .btns{
    margin-bottom: 12px
  }
</style>
